"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgPublicEvent(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "3 -4 18 24" }, props),
        React.createElement("path", { d: "M14.047 12.208l.318.863a1.086 1.086 0 01-.635 1.392l-3.939 1.47a1.075 1.075 0 01-1.383-.64l-.955-2.59 1.296-.484.85 2.302 3.362-1.256-.21-.572zM4.806 9.585l1.009 2.736-1.806.674L3 10.259zM16.64 0L21 11.823v.002l-1.805.673L14.835.673zm-2.026 1.953l3.584 9.718-11.805.173-.84-2.277z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('PublicEvent')(SvgPublicEvent);
//# sourceMappingURL=PublicEvent.js.map